import {Component, OnInit} from '@angular/core';
import {Subject} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {UniversityFacultyService} from '../../../shared/services/university-faculty.service';
import {UniversityService} from '../../../shared/services/university.service';
import {GlobalService} from '../../../shared/services/global.service';

@Component({
    selector: 'app-university-faculty',
    templateUrl: './university-faculty.component.html',
    styleUrls: ['./university-faculty.component.scss']
})
export class UniversityFacultyComponent implements OnInit {
    public name: any;
    public designation: any;
    public photoFileId: any;
    public photoPreviewUrl: any;
    public toggleMenu = false;
    private _unsubscribeAll: Subject<any>;
    public universityId: any;
    faculties: any = [];
    submitting: any = false;
    uploadingPhoto: any = false;
    university: any;

    constructor(private router: Router,
                private activatedRoute: ActivatedRoute,
                private universityFacultyService: UniversityFacultyService,
                private universityService: UniversityService,
                private globalService: GlobalService) {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.universityId = this.activatedRoute.snapshot.parent.params['id'];
        this.refresh();
    }

    refresh() {
        this.getUniversityDetail();
    }

    getUniversityDetail() {
        this.universityService.detail(this.universityId).subscribe(data => {
            if (data) {
                this.university = data;
                this.get();
            }
        });
    }

    get() {
        this.universityFacultyService.getByAdmin(this.universityId).subscribe(data => {
            this.faculties = (data && data.length > 0) ? data : [];
        });
    }

    onPhotoSelected(event) {
        this.uploadingPhoto = true;
        const params = {
            type: 'UNIVERSITY_FACULTY_PHOTO',
            fileType: 'NORMAL',
            university_id: this.universityId,
            user_id: this.globalService.getSelf() ? this.globalService.getSelf().userId : ''
        };
        this.universityFacultyService.fileUpload(params, event).subscribe(data => {
            this.uploadingPhoto = false;
            if (data && data['data']) {
                this.photoFileId = data['data'].id;
                this.photoPreviewUrl = data['data'].url;
            }
        }, error => {
            this.uploadingPhoto = false;
        });
    }

    addDetail() {
        const params = {
            name: this.name ? this.name : '',
            designation: this.designation ? this.designation : '',
            photo_file_id: this.photoFileId ? this.photoFileId : '',
            sort_order: this.faculties ? this.faculties.length : 0
        };
        this.submitting = true;
        this.universityFacultyService.createByAdmin(this.universityId, params).subscribe(data => {
            this.submitting = false;
            this.name = undefined;
            this.designation = undefined;
            this.photoFileId = undefined;
            this.photoPreviewUrl = undefined;
            this.get();
        }, error => {
            this.submitting = false;
        });
    }

    delete(id) {
        this.universityFacultyService.deleteByAdmin(this.universityId, id).subscribe(data => {
            this.get();
        });
    }

    goTo(tab) {
        this.router.navigateByUrl('university/' + this.universityId + '/' + tab);
    }
}
